import React, { useState } from 'react';
import { func, node, object, shape, string } from 'prop-types';
import classNames from 'classnames';

import Field from '../../Field';

import css from './SectionContainer.module.css';
import SectionClientFeatures from './SectionClientFeatures/SectionClientFeatures';
import SectionReviews from './SectionReviews/SectionReviews';
import SectionProfessionalFeatures from './ForProfessionals/ForProfessionals';
import SectionProjects from './SectionProjects/SectionProjects';
import SectionSearchBar from './SectionSearchBar/SectionSearchBar';
import HeroFeatureGrid from './HeroFeatureGrid/HeroFeatureGrid';
import GeneralContractors from './GeneralContractors/GeneralContractors';
import GeneralQuestionsFaq from './GeneralQuestionsFaq/GeneralQuestionsFaq';
import HireExperiencedList from './HireExperiencedList/HireExperiencedList';

// This component can be used to wrap some common styles and features of Section-level components.
// E.g: const SectionHero = props => (<SectionContainer><H1>Hello World!</H1></SectionContainer>);
const SectionContainer = props => {
  const { className, rootClassName, id, as, children, appearance, options, projects, isCurrentUserProfessional,
    isCurrentUserClient, params, ...otherProps } = props;
  const Tag = as || 'section';
  const classes = classNames(rootClassName || css.root, className);
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Tag className={classes} id={id} {...otherProps}>
      {appearance?.fieldType === 'customAppearance' ? (
        <Field
          data={{ alt: `Background image for ${id}`, ...appearance }}
          className={className}
          options={options}
        />
      ) : null}

      <div
        className={
          id === "painting-projects" ? css.paintingProjectsWrapper :
            id === "hero-feature" ? css.heroFeatureBox :
              id === "projectneed" ? css.projectNeededWrapper :
                id === "get-equipped" ? css.getEquippedWrapper :
                  id === "our-general-contractors" ? css.contractorsWrapper :
                    id === "general-questions" ? css.generalQuestions :
                      id === "hire-experience" ? css.hireExperience :
                        id === "section-reviews" ? css.sectionReviewsWrapper :
                          id === "for-professionals" ? css.forProfessionalsWrapper :
                            id === "explore-project" ? css.exploreProjectWrapper :
                              id === "footer" ? css.footerWrapper :
                                css.sectionContent}>
        {
          id === "painting-projects" ? <div>
            <SectionSearchBar
              activeTab={activeTab}
              options={options}
              params={params}
              isCurrentUserProfessional={isCurrentUserProfessional}
              isCurrentUserClient={isCurrentUserClient}
              setActiveTab={setActiveTab}
            /> </div> :
            id === "hire-experience" ? <div>
              <HireExperiencedList options={options}
                params={params}
                isCurrentUserProfessional={isCurrentUserProfessional}
                isCurrentUserClient={isCurrentUserClient}
                activeTab={activeTab} /> </div> :
              id === "hero-feature" ? <div><HeroFeatureGrid /></div> :
                id === "get-equipped" ? <div><SectionClientFeatures /></div> :
                  id === "our-general-contractors" ? <div><GeneralContractors /> </div> :
                    id === "general-questions" ? <div><GeneralQuestionsFaq /> </div> :
                      id === "section-reviews" ? <div><SectionReviews /></div> :
                        id === "for-professionals" ? <div className={css.professionalsWrapper}><SectionProfessionalFeatures /></div> :
                          id === "explore-project" ? <div><SectionProjects projects={projects} /></div> : children
        }
      </div>
    </Tag>
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

SectionContainer.defaultProps = {
  rootClassName: null,
  className: null,
  as: 'section',
  children: null,
  appearance: null,
};

SectionContainer.propTypes = {
  rootClassName: string,
  className: string,
  as: string,
  children: node,
  appearance: object,
  options: propTypeOption,
};

export default SectionContainer;
